import React from 'react'
import { Modal } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import '../modal.css'
import { SUPPORT_EMAIL } from '../../../utils/config'
import { openSupportChat } from '../../../utils/crisp'

const PaymentSupportModal = ({ openPaymentSupportModal, setOpenPaymentSupportModal }: any) => {
  const { t } = useTranslation('plan')
  return (
    <div className='custom_modal'>
      <Modal
        show={openPaymentSupportModal}
        onHide={() => setOpenPaymentSupportModal(false)}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        className='common_modal_main_div'
      >
        <Modal.Body className='mobile_align_div'>
          <div className='modal_title_div'>
            <h4 className='modal_heading'>{t('billingModals.storeManaged.title')}</h4>
            <div className='modal_close_icon_div' onClick={() => setOpenPaymentSupportModal(false)}>
              <img alt={t('billingModals.storeManaged.closeAlt')} src={'/images/close-icon-black.svg'} />
            </div>
          </div>
          <div className='ps-modal-content'>
            <p>{t('billingModals.storeManaged.body')}</p>
            <p>
              <Trans t={t} i18nKey='billingModals.storeManaged.howTo' components={{ b: <b /> }} />
            </p>
          </div>
          <div className='ps-modal-help'>
            <Trans
              t={t}
              i18nKey='billingModals.storeManaged.help'
              values={{ email: SUPPORT_EMAIL }}
              components={{
                chat: <button className='ps-modal-chat-link' onClick={() => openSupportChat()} />,
                mail: <a href={`mailto:${SUPPORT_EMAIL}`} />,
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default PaymentSupportModal
